import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/es.string.link";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}
/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2017,2020. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */


import React from 'react';
import invoke from 'lodash.invoke';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Icon from './Icon';
import IconSet from './IconSet';
import { PrimaryNavigation, SecondaryNavigation, Link } from '..';

var Header = /*#__PURE__*/function (_React$Component) {
  _inherits(Header, _React$Component);

  function Header() {
    _classCallCheck(this, Header);

    return _possibleConstructorReturn(this, _getPrototypeOf(Header).apply(this, arguments));
  }

  _createClass(Header, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      invoke(window.govhhswds, ['navigation', 'init'], document);
    }
  }, {
    key: "renderChildrenWithName",
    value: function renderChildrenWithName(name) {
      var childRenderer = React.Children.map(this.props.children, function (child) {
        return child && child.type && child.type.displayName === name && child;
      });
      return childRenderer.filter(function (el) {
        return el;
      });
    }
  }, {
    key: "renderOtherChildren",
    value: function renderOtherChildren() {
      var childRenderer = React.Children.map(this.props.children, function (child) {
        return child && child.type && child.type.displayName !== PrimaryNavigation.displayName && child.type.displayName !== SecondaryNavigation.displayName && child;
      });
      return childRenderer.filter(function (el) {
        return el;
      });
    }
  }, {
    key: "renderLogoAndAgencyName",
    value: function renderLogoAndAgencyName() {
      var _this$props = this.props,
          logo = _this$props.logo,
          title = _this$props.title;
      return React.createElement(React.Fragment, null, logo && React.cloneElement(logo, {
        className: logo.props ? classNames(logo.props.className, 'wds-c-logo__mark') : 'wds-c-logo__mark'
      }), React.createElement("span", {
        className: "wds-c-logo__type"
      }, title));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          type = _this$props2.type,
          full = _this$props2.full,
          menuButtonTitle = _this$props2.menuButtonTitle,
          to = _this$props2.to,
          link = _this$props2.link,
          menuHidden = _this$props2.menuHidden,
          titleHoverText = _this$props2.titleHoverText,
          children = _this$props2.children,
          closeIcon = _this$props2.closeIcon,
          headerControls = _this$props2.headerControls,
          primaryNavigationAriaLabel = _this$props2.primaryNavigationAriaLabel,
          secondaryNavigationAriaLabel = _this$props2.secondaryNavigationAriaLabel,
          closeButtonAriaLabel = _this$props2.closeButtonAriaLabel,
          skipNavigationLinkText = _this$props2.skipNavigationLinkText,
          mainContentId = _this$props2.mainContentId,
          title = _this$props2.title,
          logo = _this$props2.logo,
          otherProps = _objectWithoutProperties(_this$props2, ["type", "full", "menuButtonTitle", "to", "link", "menuHidden", "titleHoverText", "children", "closeIcon", "headerControls", "primaryNavigationAriaLabel", "secondaryNavigationAriaLabel", "closeButtonAriaLabel", "skipNavigationLinkText", "mainContentId", "title", "logo"]);

      var closeButton = React.createElement("button", {
        type: "button",
        className: "wds-c-nav-close",
        "aria-label": closeButtonAriaLabel
      }, closeIcon);
      var menuButton = React.createElement("button", {
        type: "button",
        className: "wds-c-menu-btn"
      }, menuButtonTitle);
      var navMenuButton = !menuHidden && menuButton;
      var primaryNavigation = this.renderChildrenWithName('PrimaryNavigation');
      var secondaryNavigation = this.renderChildrenWithName('SecondaryNavigation');
      var otherNavigationElements = this.renderOtherChildren();
      var navLink;

      if (to || link) {
        navLink = React.createElement(Link, _extends({
          className: "wds-c-logo",
          type: "default",
          to: to,
          link: link,
          title: titleHoverText
        }, otherProps), this.renderLogoAndAgencyName());
      } else {
        navLink = React.createElement("div", {
          className: "wds-c-logo"
        }, this.renderLogoAndAgencyName());
      }

      var navBar = React.createElement("div", {
        className: "wds-c-navbar"
      }, navLink && React.createElement("div", {
        className: "wds-c-navbar__logo-container"
      }, navLink, headerControls && headerControls), type === 'scrollable' && otherNavigationElements, secondaryNavigation.length > 0 && navMenuButton);

      if (skipNavigationLinkText && !mainContentId) {
        console.warn('An id for the main content was not provided for the skip navigation link');
      }

      var skipNavLink = null;

      if (skipNavigationLinkText) {
        skipNavLink = React.createElement(Link, {
          key: "skipNavigationLink",
          onClick: function onClick(e) {
            e.preventDefault(); // prevents the link from redirecting to the `main-content` route

            e.target.blur();
            var mainContent = document.getElementById(mainContentId);

            if (mainContent) {
              mainContent.scrollIntoView();
              var ios = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

              if (ios) {
                var focusable = mainContent.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');

                if (focusable[0]) {
                  focusable[0].focus();
                }
              } else {
                mainContent.focus();
              }
            }
          },
          to: "#".concat(mainContentId),
          type: "skipNav"
        }, skipNavigationLinkText);
      }

      var headerClasses = classNames('wds-c-header', "wds-c-header--".concat(type), {
        'wds-c-header--full': full
      });
      var containerClasses = classNames({
        'wds-l-container wds-l-container--large': !full,
        'wds-u-m--site': full
      });

      switch (type) {
        case 'basic':
          return [React.createElement("header", _extends({
            key: "basic-header",
            className: headerClasses
          }, otherProps), skipNavLink, React.createElement("div", {
            className: "wds-c-nav-container"
          }, navBar, (primaryNavigation.length > 0 || otherNavigationElements.length > 0) && React.createElement("nav", {
            className: "wds-c-nav"
          }, closeButton, primaryNavigation, otherNavigationElements))), React.createElement("div", {
            key: "header-overlay",
            className: "wds-c-overlay"
          })];

        case 'extended':
          return [React.createElement("header", _extends({
            key: "extended-header",
            className: headerClasses
          }, otherProps), skipNavLink, navBar, (primaryNavigation.length > 0 || secondaryNavigation.length > 0 || otherNavigationElements.length > 0) && React.createElement("nav", {
            className: "wds-c-nav"
          }, React.createElement("div", {
            className: "wds-c-nav-inner"
          }, closeButton, primaryNavigation, secondaryNavigation, otherNavigationElements))), React.createElement("div", {
            key: "header-overlay",
            className: "wds-c-overlay"
          })];

        case 'scrollable':
          return [React.createElement("header", _extends({
            key: "scrollable-header",
            className: headerClasses
          }, otherProps), skipNavLink, navBar, secondaryNavigation.length > 0 && React.createElement("nav", {
            className: "wds-c-nav",
            "aria-label": secondaryNavigationAriaLabel
          }, React.createElement("div", {
            className: "wds-c-nav-inner"
          }, closeButton, secondaryNavigation)), primaryNavigation.length > 0 && React.createElement("nav", {
            className: containerClasses,
            "aria-label": primaryNavigationAriaLabel
          }, primaryNavigation)), React.createElement("div", {
            key: "header-overlay",
            className: "wds-c-overlay"
          })];

        default:
          console.error('Invalid type provided to Header:', type);
      }

      return React.createElement("div", null);
    }
  }]);

  return Header;
}(React.Component);

Header.propTypes = {
  /** Header type. One of scrollable, basic, extended */
  type: PropTypes.oneOf(['scrollable', 'basic', 'extended']),

  /** Full width header content is not constrained by the grid  */
  full: PropTypes.bool,

  /** The menu Button text that will be displayed during responsive mode */
  menuButtonTitle: PropTypes.string,

  /**  The title that will be displayed in header */
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,

  /** The hover text that will be displayed while cursor is hovered over Title */
  titleHoverText: PropTypes.string.isRequired,

  /** The children to the header */
  children: PropTypes.node.isRequired,

  /** The path to which page will be redirected to when clicked on the title or logo */
  to: PropTypes.string,

  /** The link to which page will be redirected to when clicked on the title or logo */
  link: PropTypes.node,

  /** The bool value to indicate if the menu button need to appear */
  menuHidden: PropTypes.bool,

  /** The logo that will be displayed next to the title */
  logo: PropTypes.element,

  /** The icon for close button.
   * By default the small "close" icon from the icon set is used.
   */
  closeIcon: PropTypes.oneOfType([PropTypes.shape({
    type: PropTypes.oneOf([Icon])
  }), PropTypes.shape({
    type: PropTypes.oneOf([IconSet])
  })]),

  /** Controls visible across screen sizes */
  headerControls: PropTypes.node,

  /** aria label for primary navigation */
  primaryNavigationAriaLabel: PropTypes.string,

  /** aria label for secondary navigation */
  secondaryNavigationAriaLabel: PropTypes.string,

  /** aria label used for the menu close button */
  closeButtonAriaLabel: PropTypes.node,

  /** When defined, a `skip navigation` link is added to the Header.
   * The implementation is specific to react-router, please read the guidance
   * on cases when react-router is not used.
   * When skipNavigationLinkText is used, `mainContentId` must also be defined.
   */
  skipNavigationLinkText: PropTypes.string,

  /**
   * Use `mainContentId` in conjunction with `skipNavigationLinkText`
   * This id will be used by the skip navigation link: when the Skip to content link is clicked,
   * the header navigation elements are removed from the tab order and the focus goes to the
   * element with the id
   * defined by `mainContentId`
   */
  mainContentId: PropTypes.string
};
Header.defaultProps = {
  type: 'basic',
  full: false,
  menuButtonTitle: 'Menu',
  menuHidden: false,
  logo: undefined,
  closeIcon: React.createElement(IconSet, {
    name: "close",
    size: "small",
    decorative: true
  }),
  headerControls: undefined,
  primaryNavigationAriaLabel: 'primary navigation',
  secondaryNavigationAriaLabel: 'secondary navigation',
  closeButtonAriaLabel: 'Close',
  to: undefined,
  link: undefined,
  skipNavigationLinkText: undefined,
  mainContentId: undefined
};
export default Header;